import { object, string } from 'yup'

let phoneRegExp = /^(0)9\d{9}$/

export const editCustomerSchema = object({
  full_name: string().required('فیلد نام و نام خانوادگی الزامی است.'),
  gender: string().required('فیلد جنسیت الزامی است.'),
  mobile: string()
    .required('فیلد شماره موبایل الزامی است.')
    .matches(phoneRegExp, 'شماره موبایل وارد شده صحیح نمی باشد'),
  customer_type: string().required('فیلد دسته بندی کاربر الزامی است.'),
  birth_date: string('فیلد تاریخ تولد معتبر نیست.') | null,
  description: null,
})
